export default __webpack_public_path__ + "static/media/store_bottom_banner.9717f882.jpg";